module.exports = __webpack_public_path__ + "img/step06_b_stand_power_bottom_cross.5e352e15.png";